<script>
import { mapActions } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';

const initFormData = () => ({
  name: null,
  phone: null,
  message: null,
});

export default {
  props: {
    carsData: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    fullNameCar: {
      type: String,
      default: '',
    }
  },
  components: {
    VInput,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
  initFormData,
  data() {
    return {
      form: this.$options.initFormData(),
    };
  },
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
      message: Yup.string().required(),
    });

    return {
      schema,
    };
  },
  computed: {
    formData() {
      return {
        name: this.form.name,
        phone: this.form.phone,
        message: this.form.message,
        cars_data: this.carsData,
        action: 'form-question-answer',
      };
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send',
    }),

    onSubmit(value, actions) {
      this.send(this.formData);

      this.togglePopup('popup-message');

      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    reset() {
      this.form = this.$options.initFormData();
    },
  },
};
</script>

<template>
  <div>
    <vee-form
      :validation-schema="schema"
      novalidate
      @submit="onSubmit"
    >
      <div class="grid grid-cols-1 md:grid-cols-1 xl:grid-cols-3 gap-3.5 mb-3.5">
        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="name"
        >
          <v-input
            v-model="form.name"
            placeholder="Введите ФИО*"
            theme="white"
            format="name"
            name="name"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="phone"
        >
          <v-input
            v-model="form.phone"
            placeholder="+7 (___) ___-__-__"
            theme="white"
            format="phone"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <div class="flex items-center w-full p-1 border rounded-brand bg-white">
          <div class="h-9 rounded-brand mr-2 overflow-hidden">
            <img :src="image" alt="" class="w-auto h-full">
          </div>
          <span class="text-green leading-none">{{ fullNameCar }}</span>
        </div>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="message"
        >
          <v-input
            v-model="form.message"
            placeholder="Ваш вопрос"
            theme="white"
            :error="errorMessage"
            class="xl:col-span-3"
            @update:modelValue="handleChange"
          />
        </vee-field>
      </div>

      <button
        type="submit"
        class="button button_big block w-full xl:w-auto px-12 text-white mx-auto border-green bg-green hover:text-gray-600 hover:border-white hover:bg-white"
      >
        Отправить
      </button>
    </vee-form>
  </div>
</template>

